import { AccountTransferRequest, AccountTransferResponse } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useAccountTransfer() {
  const source = axios.CancelToken.source();
  const [accountTransferInformation, setAccountTransferInformation] = useState<AccountTransferResponse>();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const fetchAccountTransfer = async (request: AccountTransferRequest, bearer?: string) => {
    try {
      const res = await api.fetchAccountTransfer(request, bearer, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setAccountTransferInformation(res);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    accountTransferInformation,
    fetchAccountTransfer,
  };
}
